module.exports = __webpack_public_path__ + "static/img/hb_26-min.6708f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_26-min.png
// module id = Y1G+
// module chunks = 1